var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticStyle: {
            width: "100%",
            height: "34px",
            "line-height": "30px",
            "padding-left": "10px",
            "font-size": "14px",
            "background-color": "#EFEFEF"
          },
          attrs: { name: "sortHeader" }
        },
        [
          _vm._v("\n        排序字段\n        "),
          !_vm.viewMode
            ? _c(
                "span",
                { staticClass: "ml10" },
                [
                  _vm.userMode == 0
                    ? _c(
                        "el-link",
                        {
                          staticClass: "ml20",
                          staticStyle: {
                            "padding-bottom": "2px",
                            "font-size": "13px"
                          },
                          attrs: { type: "danger", size: "mini" },
                          on: {
                            click: function($event) {
                              _vm.clearSortFields()
                            }
                          }
                        },
                        [_vm._v("清除所有字段")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.userMode == 0
                    ? _c(
                        "el-link",
                        {
                          staticClass: "ml20 mr10",
                          staticStyle: {
                            "padding-bottom": "2px",
                            "font-size": "13px"
                          },
                          attrs: { type: "primary", size: "mini" },
                          on: {
                            click: function($event) {
                              _vm.addSortField()
                            }
                          }
                        },
                        [_vm._v("+ 追加字段")]
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.userMode == 2 && !_vm.viewMode
            ? _c("span", { staticClass: "fr mr5" }, [
                _vm.showExtBtns
                  ? _c(
                      "span",
                      { staticClass: "fr ml30 mr5" },
                      [
                        _vm.custSavable && _vm.onSaveCustConf != null
                          ? _c(
                              "el-button",
                              {
                                staticStyle: { "margin-top": "1px" },
                                attrs: {
                                  size: "mini",
                                  icon: "el-icon-document-checked",
                                  title: "保存调整"
                                },
                                on: {
                                  click: function($event) {
                                    _vm.handleSaveCustConf()
                                  }
                                }
                              },
                              [_vm._v("保存调整")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.custSavable && _vm.onSaveCustConf != null
                          ? _c("el-divider", {
                              attrs: { direction: "vertical" }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            staticStyle: { "margin-top": "1px" },
                            attrs: {
                              size: "mini",
                              icon: "el-icon-check",
                              title: "应用调整"
                            },
                            on: {
                              click: function($event) {
                                _vm.handleConfirm()
                              }
                            }
                          },
                          [_vm._v("应用")]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "ml20 mr5",
                            staticStyle: {
                              width: "30px",
                              height: "30px",
                              "text-align": "center",
                              "vertical-align": "middle"
                            },
                            attrs: { title: "取消/关闭" },
                            on: {
                              click: function($event) {
                                _vm.handleClose()
                              }
                            }
                          },
                          [
                            _c("i", {
                              staticClass: "el-icon-close",
                              staticStyle: { "font-size": "18px" }
                            })
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.userMode == 0 && !_vm.viewMode
            ? _c("span", { staticClass: "fr mr5" }, [
                _c(
                  "span",
                  [
                    _c("el-input", {
                      staticClass: "mr10",
                      staticStyle: { width: "100px" },
                      attrs: {
                        size: "mini",
                        placeholder: "输入 过滤文本",
                        clearable: ""
                      },
                      on: { change: _vm.filterList },
                      model: {
                        value: _vm.instantKeyword,
                        callback: function($$v) {
                          _vm.instantKeyword = $$v
                        },
                        expression: "instantKeyword"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-divider", { attrs: { direction: "vertical" } }),
                    _vm._v(" "),
                    _vm.forHisQry
                      ? _c(
                          "span",
                          [
                            _c(
                              "el-link",
                              {
                                staticClass: "ml10 mr10",
                                staticStyle: {
                                  "padding-bottom": "2px",
                                  "font-size": "13px"
                                },
                                attrs: {
                                  type: "primary",
                                  size: "mini",
                                  icon: "el-icon-notebook-2"
                                },
                                on: {
                                  click: function($event) {
                                    _vm.appendFromCols()
                                  }
                                }
                              },
                              [_vm._v("从表列选择")]
                            ),
                            _vm._v(" "),
                            _c("el-divider", {
                              attrs: { direction: "vertical" }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                !_vm.uiUnion
                  ? _c(
                      "span",
                      [
                        _c(
                          "el-link",
                          {
                            staticClass: "ml10 mr10",
                            staticStyle: {
                              "padding-bottom": "2px",
                              "font-size": "13px"
                            },
                            attrs: {
                              type: "primary",
                              size: "mini",
                              icon: "el-icon-document",
                              title: "meta sortFields"
                            },
                            on: {
                              click: function($event) {
                                _vm.inputJsonConf()
                              }
                            }
                          },
                          [_vm._v("输入json配置")]
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ])
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c(
        "el-form",
        {
          ref: "gridForm",
          staticClass: "sort-conf-form",
          attrs: { name: "gridTableWrapper", model: _vm.gridForm }
        },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "row-draggable",
                  rawName: "v-row-draggable",
                  value: _vm.makeDragCtxData(),
                  expression: "makeDragCtxData()"
                }
              ],
              ref: "gridTable",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.gridForm.fieldConfRows,
                "row-class-name": _vm.getSortRowClassName,
                "row-key": _vm.rowItemKey,
                height: _vm.gridHeight,
                stripe: "",
                "highlight-current-row": "",
                size: "mini"
              }
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: "序号",
                  width: "60",
                  align: "center",
                  type: "index",
                  fixed: ""
                }
              }),
              _vm._v(" "),
              _vm.userMode == 0
                ? _c("el-table-column", {
                    attrs: { label: "代码", width: "120" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-form-item",
                              {
                                staticStyle: { "margin-bottom": "0" },
                                attrs: {
                                  prop:
                                    "fieldConfRows[" + scope.$index + "].code"
                                }
                              },
                              [
                                _c("el-input", {
                                  staticClass: "sort-code",
                                  attrs: { maxlength: "30", size: "mini" },
                                  model: {
                                    value: scope.row.code,
                                    callback: function($$v) {
                                      _vm.$set(scope.row, "code", $$v)
                                    },
                                    expression: "scope.row.code"
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ])
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "名称", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "div",
                          { staticClass: "text" },
                          [
                            _vm.userMode == 0
                              ? _c(
                                  "el-form-item",
                                  {
                                    staticStyle: { "margin-bottom": "0" },
                                    attrs: {
                                      prop:
                                        "fieldConfRows[" +
                                        scope.$index +
                                        "].label"
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      staticClass: "sort-label",
                                      attrs: { maxlength: "20", size: "mini" },
                                      model: {
                                        value: scope.row.label,
                                        callback: function($$v) {
                                          _vm.$set(scope.row, "label", $$v)
                                        },
                                        expression: "scope.row.label"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _c("div", [_vm._v(_vm._s(scope.row.label))])
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "排序", width: "160", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-form-item",
                          {
                            staticStyle: { "margin-bottom": "0" },
                            attrs: {
                              prop: "fieldConfRows[" + scope.$index + "].order"
                            }
                          },
                          [
                            _c("el-switch", {
                              staticStyle: { "font-size": "12px" },
                              attrs: {
                                size: "mini",
                                "active-value": "desc",
                                "inactive-value": "asc",
                                "active-color": "#00438a",
                                "inactive-color": "#333333",
                                "active-text": "降序",
                                "inactive-text": "升序"
                              },
                              model: {
                                value: scope.row.order,
                                callback: function($$v) {
                                  _vm.$set(scope.row, "order", $$v)
                                },
                                expression: "scope.row.order"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "启用", width: "60", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: scope.row.enabled,
                              expression: "scope.row.enabled"
                            }
                          ],
                          attrs: { type: "checkbox" },
                          domProps: {
                            checked: Array.isArray(scope.row.enabled)
                              ? _vm._i(scope.row.enabled, null) > -1
                              : scope.row.enabled
                          },
                          on: {
                            change: function($event) {
                              var $$a = scope.row.enabled,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      scope.row,
                                      "enabled",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      scope.row,
                                      "enabled",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(scope.row, "enabled", $$c)
                              }
                            }
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              !_vm.viewMode
                ? _c("el-table-column", {
                    attrs: {
                      label: "操作/顺序",
                      width: "140",
                      align: "center"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("div", [
                              _c("i", {
                                staticClass:
                                  "icon iconfont icon-arrow-top pr10",
                                staticStyle: { cursor: "pointer" },
                                on: {
                                  click: function($event) {
                                    _vm.moveSortField(scope.$index, "prev")
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("i", {
                                staticClass:
                                  "icon iconfont icon-arrow-bottom pr10",
                                staticStyle: { cursor: "pointer" },
                                on: {
                                  click: function($event) {
                                    _vm.moveSortField(scope.$index, "next")
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _vm.userMode == 0
                                ? _c("i", {
                                    staticClass:
                                      "icon iconfont el-icon-delete pl10 pr10",
                                    staticStyle: {
                                      cursor: "pointer",
                                      color: "orange"
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.delSortField(scope.$index)
                                      }
                                    }
                                  })
                                : _vm._e()
                            ])
                          ]
                        }
                      }
                    ])
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-48ee79da", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48ee79da","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/query/SortFieldConf.vue
// module id = 1691
// module chunks = 1